var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-cart-empty"},[_c('div',{staticClass:"mini-cart-empty-body"},[_c('span',{staticClass:"mini-cart-empty-title"},[_vm._v(_vm._s(_vm.$t('miniCart.emptyTitle')))]),_c('span',{staticClass:"mini-cart-empty-desc"},[_vm._v(_vm._s(_vm.$t('miniCart.emptyDesc')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }